// Context Provider pour l'état de subscription global
// Aligné avec US-PAY-5: Gestion d'État Subscription Frontend

import React, { createContext, useContext, ReactNode } from 'react';
import { useSubscription, SubscriptionState } from '../hooks/useSubscription';

// Le type du context est directement SubscriptionState
type SubscriptionContextType = SubscriptionState;

const SubscriptionContext = createContext<SubscriptionContextType | undefined>(undefined);

interface SubscriptionProviderProps {
  children: ReactNode;
}

export const SubscriptionProvider: React.FC<SubscriptionProviderProps> = ({ children }) => {
  const subscription = useSubscription();

  return (
    <SubscriptionContext.Provider value={subscription}>
      {children}
    </SubscriptionContext.Provider>
  );
};

export const useSubscriptionContext = (): SubscriptionContextType => {
  const context = useContext(SubscriptionContext);
  if (context === undefined) {
    throw new Error('useSubscriptionContext must be used within a SubscriptionProvider');
  }
  return context;
};

/**
 * Variante non-throwing pour les composants qui peuvent être rendus dans le
 * bundle marketing public (sans SubscriptionProvider, cf. app-marketing.tsx).
 * Retourne `null` si pas de provider disponible — au caller de gérer le cas.
 *
 * Utilisé par SubscriptionBuyButton qui apparaît sur /pricing (bundle
 * marketing, sans provider) et dans le dashboard (bundle app, avec provider).
 */
export const useSubscriptionContextOptional = (): SubscriptionContextType | null => {
  const context = useContext(SubscriptionContext);
  return context ?? null;
};
